export default __webpack_public_path__ + "static/media/kanji.dbd68eac.png";